"use client"

import { cn } from "@/utils/helpers/utils"
import Link from "next/link"
import { ContentNavItem } from "@/types"
// import { ThemeToggle } from "@/components/home/ThemeToggle"
import { usePathname } from "next/navigation"
import { useSlugs } from "@/hooks/useSlugs"
import { useActiveNav } from "@/lib/active-nav-context"

export function SecondaryNavBar({ items, isOpen }: { items?: Array<ContentNavItem>; isOpen: boolean }) {
   const pathname = usePathname()
   const { toSlug } = useSlugs()
   const sortedItems = items ? [...items].sort((a, b) => a.title.localeCompare(b.title)) : []
   const { activeCategory } = useActiveNav()

   return (
      <div
         className={cn("hidden min-h-[3.5rem] w-full items-center bg-subnav-bg py-1 transition-all", isOpen && "flex")}
      >
         <div className="relative mx-auto flex w-full max-w-regular items-center justify-center">
            <div className="-ml-[2rem] flex items-center gap-4 text-subnav-text">
               {sortedItems?.map((item) => {
                  if (item.hideInDesktopNav) return null

                  const isShowChannel = item.href.startsWith("/shows/") && item.href !== "/shows/"
                  const linkHref = isShowChannel ? `/shows/${toSlug(item.title)}/` : item.href

                  const normalizedPathname = pathname.toLowerCase()
                  const normalizedLinkHref = linkHref.toLowerCase()

                  const currentSegments = normalizedPathname.split("/").filter(Boolean)
                  let itemSegments = normalizedLinkHref.split("/").filter(Boolean)

                  const isActiveByPath =
                     itemSegments.length > 0 &&
                     itemSegments.length <= currentSegments.length &&
                     itemSegments.every((segment, index) => currentSegments[index] === segment)

                  const categorySlug = activeCategory?.toLowerCase().trim().replace(/\s+/g, "-")

                  const isActiveByCategory =
                     !!categorySlug && itemSegments.length > 0 && itemSegments[itemSegments.length - 1] === categorySlug

                  const isActive = isActiveByPath || isActiveByCategory

                  return (
                     <div key={`secondary_nav_${item.title}`} className="group flex flex-col items-center">
                        <Link
                           href={linkHref}
                           className={cn(
                              "px-4 py-2 text-[16px]/[27px] font-medium text-subnav-text transition-colors group-hover:text-custom-primary",
                              isActive && "text-custom-primary",
                           )}
                        >
                           {item.title}
                        </Link>

                        <span
                           className={cn(
                              "mx-auto h-[2.5px] w-[80%] transition-all",
                              isActive ? "bg-custom-primary" : "bg-transparent group-hover:bg-custom-primary",
                           )}
                        />
                     </div>
                  )
               })}
            </div>
            {/* <div className="absolute right-4">
               <ThemeToggle />
            </div> */}
         </div>
      </div>
   )
}
